import * as React from "react";

const Search: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 16" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fill="currentColor" d="M14.769 14.674l-3.926-3.926c.85-1.04 1.318-2.35 1.318-3.78A6.093 6.093 0 006.067.876C2.702.875 0 3.603 0 6.969c0 3.365 2.728 6.093 6.067 6.093 1.43 0 2.741-.495 3.78-1.319l3.925 3.926a.81.81 0 00.525.206c.179 0 .36-.069.497-.206a.685.685 0 00-.025-.995zM1.406 6.969A4.693 4.693 0 016.094 2.28 4.693 4.693 0 0110.78 6.97a4.693 4.693 0 01-4.687 4.687A4.693 4.693 0 011.406 6.97z"/></svg>;
};

export default React.memo(Search);
